import React, { useState, useEffect } from 'react';

// Chakra imports
import {
  Box,
  Center,
  Spinner,
  Flex,
  Grid,
  Text,
  useColorModeValue,
  SimpleGrid,
  Button,
  Tooltip,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

// Custom components
import { AddIcon } from '@chakra-ui/icons';

// Assets

import CompaniesAPI from 'api/companies';
import Company from './components/companyCard';
import AddModal from './components/addModal';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { Modules } from 'config/constant';
import PageError from 'components/nopermission/PageError';

export default function Companies() {
  const [isError, setIsError] = useState('');
  // const btnVariant = useColorModeValue('lightBrand', 'darkBrand');
  const [companiesList, setCompaniesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [listTotal, setListTotal] = useState(0);
  const { getPermissionsForModule } = usePermissions();
  const [companyPermissions, setCompanyPermissions] = useState({});
  const [fetchListError, setFetchListError] = useState(false);

  const FetchCompaniesList = async () => {
    try {
      setLoading(true);
      let response = await CompaniesAPI.List({
        //  currentPage,
        //  itemsPerPage,
        sort: 'name:asc',
        // searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchListError(false);
        console.log(response.data);
        setCompaniesList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchListError(true);
        setCompaniesList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const companyPermissions = getPermissionsForModule([Modules.Company]);
    setCompanyPermissions(companyPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (companyPermissions?.read) {
      FetchCompaniesList();
    }
  }, [companyPermissions]);

  console.log('Company Permissions', companyPermissions);
  // Chakra Color Mode
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  if (!companyPermissions?.read) {
    return <NoPermissionsMessage module={Modules.Company} />;
  }
  return (
    <Box pt={{ base: '110px', md: '80px', xl: '80px' }}>
      {/* Main Fields */}
      {loading ? (
        <Center
          mt={20}
          width='100%'>
          <Spinner size='xl' />
        </Center>
      ) : fetchListError ? (
        <PageError />
      ) : (
        <Grid
          mb='20px'
          // gridTemplateColumns={{ xl: 'repeat(2, 1fr)', '2xl': '1fr 0.46fr' }}
          gap={{ base: '20px', xl: '20px' }}
          display={{ base: 'block', xl: 'grid' }}>
          <Flex
            flexDirection='column'
            gridArea={{ xl: '1 / 1 / 2 / 3', '2xl': '1 / 1 / 2 / 2' }}>
            <Flex direction='column'>
              <Flex
                mt='45px'
                mb='40px'
                justifyContent='space-between'
                direction='row'
                align='center'>
                <Text
                  color={textColor}
                  fontSize='2xl'
                  ms='24px'
                  fontWeight='700'>
                  All Companies
                </Text>
                <Tooltip
                  label={
                    !companyPermissions?.create
                      ? 'You do not have permission to add'
                      : undefined
                  }
                  placement='top'
                  shouldWrapChildren>
                  <Chakralink
                    top='14px'
                    right='14px'
                    mt={{
                      base: '0px',
                      md: '10px',
                      lg: '0px',
                      xl: '10px',
                      '2xl': '0px',
                    }}>
                    <Link
                      to={{
                        pathname: `/admin/addnewcompany`,
                      }}>
                      <Button
                        variant='lightBrand'
                        fontSize='sm'
                        fontWeight='500'
                        borderRadius='10px'
                        boxShadow='lg'
                        px='15px'
                        py='5px'
                        disabled={
                          !companyPermissions.create || !companyPermissions.read
                        }>
                        <AddIcon />
                      </Button>
                    </Link>
                  </Chakralink>
                </Tooltip>
              </Flex>
              <SimpleGrid
                columns={{ base: 1, md: 2, xl: 3, '3xl': 4 }}
                gap='20px'>
                {companiesList?.map((company) => (
                  <Company
                    key={company?.id}
                    data={company}
                    cardType='company'
                  />
                ))}
              </SimpleGrid>
            </Flex>
          </Flex>
        </Grid>
      )}

      {/* Delete Product */}
    </Box>
  );
}
